import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import sanityClient from '../sanityClient';
import { PortableText } from '@portabletext/react';
import imageUrlBuilder from '@sanity/image-url';

const cormorantFont = { fontFamily: "'Cormorant Garamond', serif" };

const builder = imageUrlBuilder(sanityClient);
function urlFor(source: any) {
  return builder.image(source).width(600).url();
}

interface NewsArticle {
  _id: string;
  title: string;
  description: string;
  publishDate: string;
  image?: any;
  content?: any;
}

function News() {
  const [articles, setArticles] = useState<NewsArticle[]>([]);
  useEffect(() => {
    sanityClient.fetch<NewsArticle[]>(
      '*[_type == "newsType"] | order(publishDate desc){_id,title,description,publishDate,image,content}'
    ).then((data: NewsArticle[]) => setArticles(data));
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      {/* News Section */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-green-700 mb-8 text-center" style={cormorantFont}>Latest News</h2>
          <div className="grid gap-8 md:grid-cols-2">
            {articles.map(article => (
              <div key={article._id} className="bg-green-50 p-6 rounded-lg shadow hover:shadow-lg transition">
                {article.image && (
                  <img
                    src={urlFor(article.image)}
                    alt={article.title}
                    className="mb-4 rounded w-full object-cover max-h-64"
                  />
                )}
                <h3 className="text-xl font-semibold text-green-800 mb-2" style={cormorantFont}>{article.title}</h3>
                <p className="text-gray-700 mb-2">{article.description}</p>
                <span className="text-green-600 text-sm block mb-2">{article.publishDate}</span>
                {article.content && (
                  <div className="prose prose-green max-w-none">
                    <PortableText value={article.content} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default News; 